import { render } from "./SensualleInfo.vue?vue&type=template&id=3cca601c&scoped=true"
import script from "./SensualleInfo.vue?vue&type=script&lang=js"
export * from "./SensualleInfo.vue?vue&type=script&lang=js"

import "./SensualleInfo.vue?vue&type=style&index=0&id=3cca601c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\sensualle\\sensualle - pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cca601c"]])

export default __exports__